module.exports = __webpack_public_path__ + "static/media/loading.8193e0a9.svg";